import React, { useState } from "react";
import styles from "./FAQ.module.css";

const faqs = [
  {
    id: 1,
    question: "What should I wear for the desert safari?",
    answer:
      "Light, comfortable clothing and closed shoes are recommended. It can get windy and sandy, so avoid loose accessories.",
  },
  {
    id: 2,
    question: "Is the dune bashing safe for children and elderly guests?",
    answer:
      "Our drivers adjust intensity based on your group. Let us know in the booking notes if you're traveling with children, pregnant guests, or anyone with back problems.",
  },
  {
    id: 3,
    question: "Can I cancel or reschedule my booking?",
    answer:
      "Yes, most packages offer free cancellation up to 24 hours before your scheduled pickup time.",
  },
  {
    id: 4,
    question: "Do you offer hotel pickup and drop-off?",
    answer:
      "Yes, pickup and drop-off from your Dubai hotel or residence is included in every package.",
  },
];

function FAQ() {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className={styles.section}>
      <div className="container">
        <h2 className={styles.title}>Frequently Asked Questions</h2>

        <div className={styles.accordion}>
          {faqs.map((faq) => (
            <div key={faq.id} className={styles.item}>
              <button
                type="button"
                className={styles.question}
                onClick={() => toggle(faq.id)}
                aria-expanded={openId === faq.id}
              >
                {faq.question}
                <span className={styles.toggleIcon}>
                  {openId === faq.id ? "−" : "+"}
                </span>
              </button>
              {openId === faq.id && (
                <p className={styles.answer}>{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
